<template>
  <div>
    <div class="d-flex text-left d-flex JOIN-ITEM">
      <img
          class="IMAGE m-r-2 m-t-1 as-start"
          :src="item.image"
      />
      <div class=" d-flex fd-column">
        <div class="TITLE text-bold">{{item.title}}</div>
        <p class="p-b-2">{{item.description}}</p>
        <a v-if="item.modal" class="LINK" @click="toggleModalOpen">{{item.linkText}}</a>
        <a v-else class="LINK" :href="item.linkUrl" target="_self">{{item.linkText}}</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'how-to-join-item',
  props: {
    item: {
      type: Object,
      require: true,
    },
  },
  data () {
    return {
      isModalOpen: false,
    };
  },
  methods: {
    toggleModalOpen () {
      this.$emit('modal-open', this.item.modal);
      this.isModalOpen = true;
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.TITLE {
  text-align: left;
  font-size: 22px;
}
.IMAGE {
  align-self: center;
  width: 24px;
  height: auto;
}
.JOIN-ITEM {
  margin: 4 * $unit;
}
.LINK {
  text-decoration: underline;
  color: $color-depot;
  cursor: pointer;
}
</style>
